// 项目开发修改该文件配置，其他文件尽量保持统一，如其他文件需要修改，先想对应对应技术负责人确认后执行修改
// 不同项目尽量格式相同，部分内容需要和后端确定
const config = {
  // test 大法的token
  _getTestToken: () => {
    return "";
  },
  // 地址参数添加userID
  _getTestUserId: () => {
    return "";
  },
  // 获取当前环境
  _getEvn: () => {
    return process.env.NODE_ENV;
  },
  // 获取当前项目成功状态码
  _getSuccessCode: () => {
    return 0;
  },
  // 获取当前项目登录超时状态码
  _getLoginOutCode: () => {
    return 400100103;
  },
  // 获取当前项目无权限状态码
  _getNoPowerCode: () => {
    return 400100901;
  },
  // 获取当前项目无权限状态码，特定页面
  _getNoPowerCodeComSelect: () => {
    return 400100011;
  },
  // 获取登录验证码
  _getCaptchaCode: () => {
    return 400100009;
  },
  // 无权限页面路径
  _getNoPowerUrl: () => {
    return "/rhqy/index.html#/noPower";
  },
  // 无权限页面路径，特定页面
  _getNoPowerComSelectUrl: () => {
    return "/rhqy/index.html#/rhqy/noPower";
  },
  // 获取统一数据结构的code值和errmsg值
  _getResCodeAndErrMsg: res => {
    return { code: Number(res.data.errcode), errmsg: res.data.errmsg };
  },
  // 获取登录路径
  _getLoginAuthorizeUrl: res => {
    let loginUrl = res.data.loginUrl || "#/rhqy/login";
    // let thisUrl = encodeURIComponent(window.location.href);
    // console.log(loginUrl + thisUrl)
    return loginUrl;
  }
};
module.exports = config;
